import React from 'react';

const spinStyle = `
  .flowium-spin {
    animation: flowiumSpin 3s linear infinite;
  }
  @keyframes flowiumSpin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

const LoadingPage: React.FC = () => {
  return (
    <>
      <style>{spinStyle}</style>
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-surface">
        <img src="/logos/flowium_icon.svg" alt="Flowium loading" className="h-16 w-16 flowium-spin" />
      </div>
    </>
  );
};

export default LoadingPage;
